<template>
  <b-row align-v="start" no-gutters>
    <b-col v-if="item.product.image" cols="auto">
      <b-img alt="" class="img-border product-image" :src="getImage(item.product.image.original)" />
    </b-col>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <b-col class="ml-2">
      {{ item.product.name }}
      <div v-if="item.product.description" v-html="item.product.description"></div>
    </b-col>
    <b-col>
      <h3 class="my-0 text-right">
        <span :style="{ textDecoration: Number(item.subtotal) !== Number(item.subtotal - item.discount) ? 'line-through' : '' }">
          {{ $n(item.subtotal, 'currency') }}
        </span>
        <span v-if="Number(item.subtotal) !== Number(item.subtotal - item.discount)" class="ml-1">
          <span v-if="Number(item.subtotal - item.discount) > 0">{{ $n(item.subtotal - item.discount, 'currency') }}</span>
          <span v-else>{{ $t('components.totals.free') }}</span>
        </span>
      </h3>
      <b-button block class="m-0 p-0 text-right" variant="link" @click="$emit('remove-item', item.id)">{{ $t('dp.generic.remove') }}</b-button>
    </b-col>
  </b-row>
</template>

<script>
import { getImage } from '@/utils';

export default {
  name: 'MembershipSubscriptionProduct',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
  },
  methods: {
    getImage,
  },
};
</script>

<style scoped></style>
